// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__uLTHL","slowMotion":"Button_slowMotion__2TeF6"};